import React from 'react';
import PageTitle from '../../components/PageTitle/PageTitle';
import translateString from '../../utils/Locales';
import { NineCellLoading } from 'react-loadingg';
import getClient from '../../services/getClient';
import Cookies from 'universal-cookie';
import '../landingPage/style.css';
import getSubscriptionDetails from '../../services/getSubscriptionDetails';
import moment from 'moment';
import cancelSubscription from '../../services/cancelSubscription';
import sendMail from '../../services/sendMainEmail';
import { canceledSubscriptionBody } from '../../utils/consts';

let t = translateString;

export default class ManagePayments extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            isLoading: true,
        };
    }

    async componentDidMount() {
        
        const cookies = new Cookies();
        const db = cookies.get('db', { path: '/' });
        let cliente = await getClient('', '', db);

        if (cliente.type === '1') {

            let res = await getSubscriptionDetails(cookies.get('username', { path: '/' }), cookies.get('token', { path: '/' }), cliente.subscription_id);
            console.log(res);

            if(res !== null && res !== undefined) {

                if (res.status === 'CANCELLED') {
                    let last_payment = res.billing_info.last_payment.time;
                    let date = moment(last_payment, 'yyyy-MM-DDTHH:mm:ssZ');
                    let now = moment();
                    if (now > date.add(1, 'month')) {
                        this.setState({ isLoading: false, cliente: cliente, subscription: { status: 'EXPIRED' } });
                    } else {
                        let sub = { status: res.status, next_payment: res.billing_info.next_billing_time }
                        this.setState({ isLoading: false, cliente: cliente, subscription: sub });
                    }
                } else {
                    let sub = { status: res.status, next_payment: res.billing_info.next_billing_time }
                    this.setState({ isLoading: false, cliente: cliente, subscription: sub });
                }
            }
        } else {
            this.setState({ isLoading: false, cliente: cliente, subscription: { status: 'EXPIRED' } });
        }
    }

    async closeSubscription() {
        if (window.confirm(t('chiudi_abbonamento'))) {
            
            this.setState({ isLoading: true });

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });

            await cancelSubscription(username, token, this.state.cliente.subscription_id);
            await sendMail(this.state.cliente.mail, this.state.cliente.ragioneSociale, t('dispiaciuti'), canceledSubscriptionBody(this.state.cliente.ragioneSociale));
            
            this.setState({ isLoading: false, subscription: { status: 'CANCELLED' } });
        }
    }

    render() {

        if (this.state.isLoading) return <NineCellLoading style={{ position: 'absolute', left: '55%', top: '50%' }} />;
        return(
            <>
                <PageTitle title={t('gestisci_pagamenti')} />
                { this.state.cliente.type === '1' && (
                    <div style={{ ...mainView, position: 'relative', paddingBottom: 50 }}>
                        <h4 style={{ fontWeight: 'bold' }}>{t('tuo_account')} <span style={{ color: 'gold' }}>PREMIUM</span></h4>
                        <h6 style={{ fontWeight: 'bold', color: '#828282' }}>49 € {t('piu_iva')} {t('mese')}</h6>

                        <p style={{ marginTop: 30 }}>{t('sub_momento')} <b>{(this.state.subscription.status === 'ACTIVE' || this.state.subscription.status === 'CANCELLED') ? t('abbonamento_attivo') : t('abbonamento_non_attivo')}</b> {this.state.subscription.status === 'ACTIVE' && t('rinn_mensile')}</p>
                        { this.state.subscription.status === 'ACTIVE' && <p style={{ marginTop: 15 }}>{t('prossimo_rinnovo')} {moment(this.state.subscription.next_payment, 'yyyy-MM-DDTHH:mm:ssZ').format('DD/MM/yyyy')}. {t('pagamento_info')}</p> }
                        { this.state.subscription.status === 'ACTIVE' && <span style={{ position: 'absolute', bottom: 20, right: 20, color: 'red', cursor: 'pointer' }} onClick={this.closeSubscription.bind(this)}>{t('annulla_piano')}</span> }
                        { this.state.subscription.status === 'CANCELLED' && <p style={{ marginTop: 15 }}>{t('pagamento_cancellato')}</p> }
                    </div>
                )}
            </>
        );
    }
}

const mainView = {
    backgroundColor: 'white', 
    borderRadius: '10px', 
    padding: '30px',
    boxShadow: '0px 2px 10px lightgrey', 
    width: '90%',
}